module.exports = __webpack_public_path__ + "static/img/service_passprime_icon_2.a325fe9d.svg";